import { Pipe, PipeTransform } from '@angular/core';
import { isValidUrl } from '../text-utils';
@Pipe({
  name: 'isNotReportUrl',
  standalone: false
})
export class IsNotReportUrlPipe implements PipeTransform {
  transform(value: string): boolean {
    if (value === undefined || value === null || value === '')
      return false;
    console.log('IsReportUrlPipe: Checking if value is a valid URL:', isValidUrl(value));
    if (isValidUrl(value)) {
      return false;
    }
    const urlStartTag = '[url]';
    const urlEndTag = '[\\url]';
    const startIndex = value.indexOf(urlStartTag);
    const endIndex = value.indexOf(urlEndTag);
    if (startIndex !== -1 && endIndex !== -1 && startIndex < endIndex) {
          console.log('one');
      return false;
    } else {
      console.log('two');
      return true;
    }
  }
}